import useDataTypeInput from './data-type-input.controller';

export interface DataTypeInputProps {
    onChange: (value: string | string[] | number | boolean | null) => void;
    type: string;
    value: string | number | boolean | undefined | null;
    label: React.ReactNode;
    submitted: boolean;
    className?: string;
    disabled?: boolean;
    options?: string[] | number[];
    default?: string | number;
    helpMessage?: React.ReactNode;
}

export const DataTypeInput = (props: DataTypeInputProps) => {
    const viewProps = useDataTypeInput(props);

    return viewProps.input;
};
